export default "__VITE_ASSET__bpvR3WAB__"